<template>
  <div>
    <div v-if="loading" class="loading d-flex justify-content-center align-items-center">
      <b-spinner
          small
          type="grow" />
      <b-spinner
          small
          type="grow" />
      <b-spinner
          small
          type="grow" />
    </div>
    <h5>{{ $t('configuration.import.lot.title') }}</h5>
    <b-row align-h="center">
      <b-col
        sm="4"
        class="m-0 p-0">
        <b-form-file
          v-model="file"
          :placeholder="$t('formLoadFile')"
          accept=".json" />
      </b-col>
      <b-col
        sm="1"
        class="m-0 px-1">
        <b-button
            v-if="loading"
            disabled>
          <b-spinner
              small
              type="grow" />
          <b-spinner
              small
              type="grow" />
          <b-spinner
              small
              type="grow" />
        </b-button>
        <b-button
            v-else
            @click="importFile"
        >
          {{ $t('importButton') }}
        </b-button>
      </b-col>
      <app-confirmation-modal
        ref="lotNameModal"
        :title="$t('modal.import.title', {version: nameAlreadyTaken})"
        ok-button-prevent-hiding
        ok-button-spinners-enabled
        @ok="sendNewLotName">
        <p>{{ $t('modal.import.message') }}</p>
        <b-form-input
          v-model="versionName" />
      </app-confirmation-modal>
    </b-row>
  </div>
</template>

<script>
import {importLot} from '../../../../service/GenefoxService';
import NotificationMixin from '../../../../mixins/NotificationMixin';
import ConfirmationModal from '@/components/common/ConfirmationModal.vue';

export default {
  components: {
    'app-confirmation-modal' : ConfirmationModal
  },
  mixins: [
    NotificationMixin
  ],
  data() {
    return {
      file: undefined,
      versionName: undefined,
      nameAlreadyTaken: undefined,
      loading: false
    };
  },
  methods: {
    checkFile() {
      if (!this.file) {
        this.showErrorNotification(this.$t('configuration.import.kit.notification.error.title'),
            this.$t('configuration.import.missingFile'));
        return false;
      }
      if (this.file.type !== 'application/json') {
        this.showErrorNotification(this.$t('configuration.import.kit.notification.error.title'),
            this.$t('configuration.import.wrongExtension'));
        return false;
      }
      return true;
    },
    async importFile() {
      const isFileIsValid = this.checkFile();
      this.loading = true;
      await this.$nextTick();
      if(isFileIsValid) {
        importLot(this.file)
            .then(name => {
              if (!name) {
                this.showSuccessNotification(this.$t('configuration.import.lot.notification.success.title'),
                    this.$t('configuration.import.lot.notification.success.message'));
              } else {
                this.nameAlreadyTaken = name;
                this.$refs.lotNameModal.showModal();
              }
            })
            .catch(error => this.showErrorNotification(this.$t('configuration.import.lot.notification.error.title'), error))
            .finally(() => this.loading = false);
      } else {
        this.loading = false;
      }
    },
    sendNewLotName() {
      const isFileIsValid = this.checkFile();
      if (!this.versionName) {
        this.showErrorNotification(this.$t('configuration.import.lot.notification.error.title'),
          this.$t('configuration.import.kit.notification.error.versionNameIsNull'));

        return ;
      }
      if(isFileIsValid) {
        importLot(this.file, this.versionName)
            .then(name => {
              if (!name) {
                this.showSuccessNotification(this.$t('configuration.import.lot.notification.success.title'),
                    this.$t('configuration.import.lot.notification.success.message'));
              } else {
                this.showErrorNotification(this.$t('configuration.import.lot.notification.error.title'),
                    this.$t('configuration.import.versionAlreadyExists', {version: this.versionName}));
              }
            })
            .catch(error => this.showErrorNotification(this.$t('configuration.import.lot.notification.error.title'), error))
            .finally(() => this.$refs.lotNameModal.hideModal());
      } else {
        this.$refs.lotNameModal.hideModal();
      }
    }
  }
};
</script>
